import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout de Configuracoes > Integracoes: o catalogo (/configuracoes/integracoes) e as paginas de cada integracao. */
export const Route = createFileRoute('/_app/configuracoes/integracoes')({
  component: IntegracoesLayout,
});

function IntegracoesLayout() {
  return <Outlet />;
}
